import type { EstadoBloco } from '@/lib/perfilEvento';

interface Props {
  icone: string;
  titulo: string;
  resumo?: string;
  estado: EstadoBloco | null;
  aoAbrir: () => void;
}

function SeloEstado({ estado }: { estado: EstadoBloco }) {
  if (estado === 'completo') {
    return (
      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-success-100 text-success-700">
        <i className="ri-check-line text-sm" />
      </span>
    );
  }
  if (estado === 'falta') {
    return (
      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700">
        <i className="ri-alert-line text-sm" />
      </span>
    );
  }
  return (
    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-secondary-300 text-secondary-400">
      <span className="h-2 w-2 rounded-full border border-current" />
    </span>
  );
}

export default function CartaoBloco({ icone, titulo, resumo, estado, aoAbrir }: Props) {
  return (
    <button
      type="button"
      onClick={aoAbrir}
      className="flex w-full cursor-pointer items-center gap-3 rounded-lg border border-secondary-200 bg-white px-4 py-3.5 text-left transition-colors hover:border-primary-300 hover:bg-background-50"
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
        <i className={icone} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[15px] font-medium text-foreground-950">{titulo}</span>
        {resumo && <span className="mt-0.5 block truncate text-xs text-secondary-500">{resumo}</span>}
      </span>
      {estado && <SeloEstado estado={estado} />}
      <span className="flex h-5 w-5 shrink-0 items-center justify-center text-secondary-400">
        <i className="ri-arrow-right-s-line text-xl" />
      </span>
    </button>
  );
}